<template>
    <div>
        <Form ref="formItem" :label-width="80" :model="formCustom" :rules="ruleInline">
            <Form-item label="真实姓名" prop="name">
                <Input type="text" v-model="formCustom.name"></Input>
            </Form-item>
            <Form-item label="手机号" prop="phone">
                <Input type="text" v-model="formCustom.phone"></Input>
            </Form-item>
            <Form-item label="账户名" prop="username">
                <Input type="text" v-model="formCustom.username"></Input>
            </Form-item>
            <Form-item label="密码" prop="password">
                <Input type="text" v-model="formCustom.password"></Input>
            </Form-item>
            <Form-item label="管理员" prop="type">
                <Select v-model="formCustom.type" placeholder="请选择">
                    <Option :value="0">高级管理员</Option>
                    <Option :value="1">中级管理员</Option>
                    <Option :value="2">初级管理员</Option>
                </Select>
            </Form-item>
            <Form-item label="区域" prop="area">
                <Select v-model="formCustom.area" placeholder="请选择">
                    <Option :value="1">业务东区</Option>
                    <Option :value="2">业务南区</Option>
                    <Option :value="3">业务西区</Option>
                    <Option :value="4">业务北区</Option>
                </Select>
            </Form-item>
            <Form-item>
                <Button type="primary" @click="submitFn('formItem')">提交</Button>
                <Button type="ghost" @click="resetFn('formItem')" style="margin-left: 8px">重置</Button>
            </Form-item>
        </Form>
        <el-dialog title="提交" :visible.sync="addShow">
            <p>确认要提交？</p>
            <div slot="footer" class="dialog-footer">
                <Button @click="addShow=false">取 消</Button>
                <Button type="primary" @click="axiosFn">确 定</Button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default{
        data(){
            const nameRegexp = (rule, value, callback) =>{
                if(!/^[\u4e00-\u9fa5]{2,4}$/.test(value)){
                    callback(new Error('真实姓名格式不对，请输入2-4位中文字符'));
                }else{
                    callback();
                }
            };
            const phoneRegexp = (rule, value, callback) =>{
                if(!/^(13[0-9]|14[5|7|9]|15[0-3|5-9]|17[0|1|3|5-8]|18[0-9])\d{8}$/.test(value)){
                    callback(new Error('手机号格式不对'));
                }else{
                    callback();
                }
            };
            const usernameRegexp = (rule, value, callback) => {    //门店校验
                if(!/^[a-zA-Z0-9]{6,12}$/.test(value)){
                    callback(new Error('账户名格式不对，请输入6-12位英文加数字'));
                }else{
                    callback();
                }
            };
            const passwordRegexp = (rule, value, callback) => {    //门店校验
                if(!/^[a-zA-Z0-9]{6,12}$/.test(value)){
                    callback(new Error('密码格式不对，请输入6-12位英文和数字'));
                }else{
                    callback();
                }
            };
            return {
                formCustom:{
                    name:null,
                    phone:null,
                    username:null,
                    password:null,
                    type:null,
                    area:null,
                },
                addShow:false,
                ruleInline: {
                    name: [
                        { required: true, message: '真实姓名不能为空', trigger: 'blur' },
                        { validator: nameRegexp, trigger: 'blur' },
                    ],
                    phone: [
                        { required: true, message: '手机号不能为空', trigger: 'blur' },
                        { validator: phoneRegexp, trigger: 'blur' },
                    ],
                    username: [
                        { required: true, message: '账户名不能为空', trigger: 'blur' },
                        { validator: usernameRegexp, trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: '密码不能为空', trigger: 'blur' },
                        { validator: passwordRegexp, trigger: 'blur' },
                    ],
                    type: [
                        { required: true, type:'number', message: '管理员类型不能为空', trigger: 'blur' },
                    ]
                }
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
        },
        methods:{
            submitFn(name){
                var _this=this;
                _this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.addShow=true;
                    } else {
                        _this.$Message.error('表单验证失败!');
                    }
                })
            },
            axiosFn(){
                this.addShow=false;
                var _this=this;
                _this.$http.get('/web/admin/addAdminEntity',{
                    params:_this.formCustom
                }).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title: '新建用户',
                            desc: res.message,
                        });
                        _this.$router.push({path:'/Right'});
                    }else{
                        _this.$Notice.error({
                            title: '新建用户',
                            desc: res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title: '新建用户',
                        desc: '表单提交失败',
                    });
                })
            },
            resetFn(name){
                this.$refs[name].resetFields();
            },
        }
    }
</script>
<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/rights/addRight.vue